function Authorization($rootScope, $state, permissionService, loggerService, PermPermissionStore, $q, organizationService) {
  $rootScope.$on('$stateChangePermissionStart', (event, toState, toParams) => {
    //NOTE: this is kind of weird, but the issue was that $stateParams.organizationId isn't set before the first time Angular Permissions tries to
    //verify permissions on a route, but we need the current org ID in the URL to know which permissions to load. So we use this event, which is fired before
    //Anguar Permissions checks permissions and has access to the route params (super weird) and set it in memory so the permission service can load the right permissions

    if (toParams.organizationId) {
      organizationService.setCurrentOrganizationId(toParams.organizationId);
    }
  });

  PermPermissionStore.definePermission('canReadOrganization', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId || transitionProperties.toParams.id;

    if (!orgId) return $q.reject(_missingParamError('orgId'));

    return permissionService.canReadOrganization(orgId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canWriteOrganization', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId || transitionProperties.toParams.id;

    if (!orgId) return $q.reject(_missingParamError('orgId'));

    return permissionService.canWriteOrganization(orgId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canManageStaff', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId;

    if (!orgId) return $q.reject(_missingParamError('orgId'));

    return permissionService.canManageStaff(orgId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canExportCustomers', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId;

    if (!orgId) return $q.reject(_missingParamError('orgId'));

    return permissionService.canExportCustomers(orgId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadVenue', (permissionName, transitionProperties) => {
    const venueId = transitionProperties.toParams.venueId;

    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return permissionService.canReadOrWriteVenue(venueId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canWriteVenue', (permissionName, transitionProperties) => {
    const venueId = transitionProperties.toParams.venueId || transitionProperties.toParams.id;

    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return permissionService.canWriteVenue(venueId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadEvents', (permissionName, transitionProperties) => {
    const venueId = transitionProperties.toParams.venueId || transitionProperties.toParams.id;

    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return permissionService.canReadEvents(venueId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canWriteEvents', (permissionName, transitionProperties) => {
    const venueId = transitionProperties.toParams.venueId || transitionProperties.toParams.id;

    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return permissionService.canWriteEvents(venueId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadPerformanceReports', (permissionName, transitionProperties) => {
    const venueId = transitionProperties.toParams.venueId || transitionProperties.toParams.id;

    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return permissionService.canReadPerformanceReports(venueId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  //multiple permission combinations
  // ng-permissions - when using multiple permission it will OR them, so to do an AND you must create another PermissionDefinition:
  //https://github.com/Narzerus/angular-permission/wiki/Usage-in-ui-router-states#multiple-permissionsroles

  PermPermissionStore.definePermission('canReadVenueAndCanReadReservations', (permissionName, transitionProperties) => {
    const venueId = transitionProperties.toParams.venueId || transitionProperties.toParams.id;

    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return $q.all([
        permissionService.canReadOrWriteVenue(venueId),
        permissionService.canReadOrWriteReservations(venueId)
      ])
      .then(results => {
        return (results && results[0] && results[1]) ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadVenueAndCanReadGuestlists', (permissionName, transitionProperties) => {
    const venueId = transitionProperties.toParams.venueId || transitionProperties.toParams.id;

    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return $q.all([
        permissionService.canReadOrWriteVenue(venueId),
        permissionService.canReadOrWriteGuestlists(venueId)
      ])
      .then(results => {
        return (results && results[0] && results[1]) ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadOrganizationAndCanManageStaff', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId;

    if (!orgId) return $q.reject(_missingParamError('venueId'));

    return $q.all([
        permissionService.canReadOrganization(orgId),
        permissionService.canManageStaff(orgId)
      ])
      .then(results => {
        return (results && results[0] && results[1]) ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadOrganizationAndCanManageCustomers', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId;

    if (!orgId) return $q.reject(_missingParamError('orgId'));

    return $q.all([
        permissionService.canReadOrganization(orgId),
        permissionService.canManageCustomers(orgId)
      ])
      .then(results => {
        return (results && results[0] && results[1]) ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadOrganizationAndCanExportCustomers', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId;

    if (!orgId) return $q.reject(_missingParamError('orgId'));

    return permissionService.canReadOrganization(orgId) &&
      permissionService.canExportCustomers(orgId)
      .then(hasPermission => {
        return hasPermission ? $q.resolve(true) : $q.reject(false);
      });
  });

  PermPermissionStore.definePermission('canReadOrganizationAndCanReadVenue', (permissionName, transitionProperties) => {
    const orgId = transitionProperties.toParams.organizationId;
    const venueId = transitionProperties.toParams.venueId || transitionProperties.toParams.id;

    if (!orgId) return $q.reject(_missingParamError('orgId'));
    if (!venueId) return $q.reject(_missingParamError('venueId'));

    return $q.all([
        permissionService.canReadOrganization(orgId),
        permissionService.canReadOrWriteVenue(venueId)
      ])
      .then(results => {
        return (results && results[0] && results[1]) ? $q.resolve(true) : $q.reject(false);
      });
  });

  function _missingParamError(paramName) {
    return new Error(`missing param ${paramName}`);
  }
}

Authorization.$inject = [
  '$rootScope',
  '$state',
  'permissionService',
  'loggerService',
  'PermPermissionStore',
  '$q',
  'organizationService'
];

export default Authorization;



// WEBPACK FOOTER //
// ./src/authorization.js